import { some, get, isArray, endsWith, map, isEmpty, filter } from "lodash";
import type { RootState } from "types/state";

// given x actions return if any are in a loading state
export const createLoadingSelector =
  (actions: string | string[]) =>
  (state: RootState): boolean => {
    // allow passing in single instance vs array
    const actionsToIterate = !isArray(actions) ? [actions] : actions;

    // returns true when any of the given actions is in a loading state
    return some(actionsToIterate, (action) => get(state, `loading.${action}`));
  };

// given x actions return if any are in an errored state
export const createErrorSelector =
  (actions: string | string[]) =>
  (state: RootState): string => {
    // allow passing in single instance vs array
    const actionsToIterate = !isArray(actions) ? [actions] : actions;
    const actionsWithErrors = filter(actionsToIterate, (action: string) =>
      get(state, `error.${action}`)
    );
    if (isEmpty(actionsWithErrors)) {
      return "";
    }

    return map(actionsWithErrors, (action: string) => {
      const errorMsg = get(state, `error.${action}`);
      return endsWith(errorMsg, ".") ? errorMsg : errorMsg + ".";
    }).join(" ");
  };
